import { Component, Input } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { CallBackService } from 'src/app/features/callback/services/CallBack.service';
import { ControlPanelService } from '../../services/ControlPanel.service';

@Component({
  selector: 'user-card',
  templateUrl: './user-card.component.html',
  styleUrls: ['./user-card.component.css']
})
export class UserCardComponent {

  @Input() totalLocations: number = 0;
  @Input() totalGeofences: number = 0;
  userName: string = "";
  regularName: string = "";

  public $rolItem: Observable<string[]> = new Observable<string[]>();

  subscription_rolItem: Subscription;

  constructor(private callbackService: CallBackService, public controlPanelService : ControlPanelService) { 
    this.$rolItem = this.callbackService.getRolItem();
    // this.subscription_rolItem = this.$rolItem.subscribe((element) => {
    //   this.controlPanelService.rolItem = element;
    // });
  }

  ngOnInit(): void {
    // var categoriesString = localStorage.getItem('listaCategorias');
    // if (categoriesString != null && categoriesString != undefined && categoriesString != '') {
    //   var categories = JSON.parse(categoriesString);
    //   categories.forEach(element => {
    //     this.totalLocations += element.total;
    //   });
    // }
    // this.totalGeofences = 4;

    var userString = localStorage.getItem('userName');
    if (userString != null && userString != undefined && userString != '') {
      this.userName = userString;
    }

    var regularName = localStorage.getItem('regularName');
    if (regularName != null && regularName != undefined && regularName != '') {
      this.regularName = regularName;
    }
  }

  ngOnDestroy(): void {
    if (this.subscription_rolItem) {
      this.subscription_rolItem.unsubscribe();
    }
  }

}
